import { createSelector } from 'reselect';
import { NavState, Routes } from './types';
import { initialNavState } from './slice';
import { RootState } from '../types';

export const selectNavDomain = (state: RootState): NavState => {
  return state?.navigator || initialNavState;
};

export const selectCurrentAppRoute = createSelector([selectNavDomain], (state) => state.currentAppRoute);
export const selectRoutesStates = createSelector([selectNavDomain], (state) => state.routeStates);
export const selectRouteSequence = createSelector([selectNavDomain], (state) => state.routeSequence);
export const selectRouteContext = createSelector([selectNavDomain], (state) => state.routeContext);
export const selectStepNumber = createSelector([selectNavDomain], (state: NavState) => state.currentStep);
export const selectTotalSteps = createSelector([selectNavDomain], (state: NavState) => state.totalSteps);

export const selectMaxRoute = createSelector([selectNavDomain], (state: NavState) => state.maxRoute);
export const selectCurrentStepNumber = createSelector([selectNavDomain], (state: NavState) => state.currentStep);

export const selectIsMaxRouteGreaterThanScheduleInstallation = createSelector([selectNavDomain], (state: NavState) =>
  Boolean(
    state.routeStates &&
      state.routeStates[state.maxRoute].order > state.routeStates[Routes.SCHEDULE_INSTALLATION].order,
  ),
);

export const selectIsMaxRouteGreaterThanCreditCheck = createSelector(
  [selectNavDomain],
  (state: NavState) =>
    state.routeStates && state.routeStates[state.maxRoute].order > state.routeStates[Routes.CREDIT_CHECK].order,
);
